import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RecordOfAllBut, WithId } from 'src/replicant/utils/types';
import { GCInstant as platform } from 'src/lib/gcinstant';

const initialLevelState = {
  current: 0,
  xp: 0,
};

export type LevelState = typeof initialLevelState;
const initialState: RecordOfAllBut<string, LevelState, keyof LevelState> = {};

const { actions, reducer } = createSlice({
  name: 'level',

  initialState,

  reducers: {
    setLevel: (
      level,
      { payload: { id, payload } }: PayloadAction<WithId<Partial<LevelState>>>,
    ) => {
      Object.assign(level[id], payload);
    },

    createLevel: (
      level,
      { payload: { id, payload } }: PayloadAction<WithId<Partial<LevelState>>>,
    ) => {
      level[id] = { ...initialLevelState, ...payload };
    },

    deleteLevel: (level, { payload: id }: PayloadAction<string>) => {
      delete level[id];
    },
  },

  extraReducers: (builder) => {
    builder.addCase('RESET_APP', () => ({
      [platform.playerID]: initialLevelState,
    }));
  },
});

export const levelActions = actions;
export default reducer;
